import React, { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import './BtsTermsBox.css';

const BtsTermsBox = ({ title, terms }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="bts-terms-box">
      <button className="bts-terms-box__header" onClick={() => setOpen(!open)}>
        <span className="bts-terms-box__title">{title}</span>
        {open ? <FiChevronUp size={16} /> : <FiChevronDown size={16} />}
      </button>
      {open && (
        <ul className="bts-terms-box__list">
          {terms.map((term, i) => (
            term.startsWith('-') || term.startsWith('- ') ? (
              <li key={i} className="bts-terms-box__item bts-terms-box__item--sub">{term}</li>
            ) : (
              <li key={i} className="bts-terms-box__item">{term}</li>
            )
          ))}
        </ul>
      )}
    </div>
  );
};

export default BtsTermsBox;
